import styled, { css } from 'styled-components'

export const TxPage = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f3ef 0%, #ebe4dc 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 12px 24px;
  box-sizing: border-box;
`

export const BillCard = styled.div`
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 6px 24px rgba(66, 35, 3, 0.1);
  overflow: hidden;
`

export const BillHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 16px 12px;
  border-bottom: 1px dashed #e8e0d8;
`

export const LogoCircle = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow:
    0 4px 14px rgba(66, 35, 3, 0.14),
    0 1px 3px rgba(66, 35, 3, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 10px;
  padding: 8px;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const LogoPlaceholder = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #f3eee9;
  border: none;
  box-shadow:
    0 4px 14px rgba(66, 35, 3, 0.14),
    0 1px 3px rgba(66, 35, 3, 0.08);
  margin-bottom: 10px;
`

export const BillTitle = styled.h1`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #422303;
  line-height: 1.35;
  word-break: break-word;
`

export const StatusBanner = styled.div`
  text-align: center;
  padding: 16px 16px 8px;

  svg {
    width: 48px;
    height: 48px;
    margin-bottom: 6px;
  }

  .title {
    font-size: 15px;
    font-weight: 700;
  }

  .hint {
    margin-top: 6px;
    font-size: 11px;
    color: #8a7a6a;
  }

  ${({ success }) =>
    success
      ? css`color: #07b558;`
      : css`color: #9e0823;`
  }
`

export const AmountBlock = styled.div`
  margin: 8px 16px 4px;
  padding: 10px 12px;
  background: #faf7f4;
  border-radius: 10px;
  text-align: center;

  .label {
    font-size: 11px;
    color: #8a7a6a;
    margin-bottom: 2px;
  }

  .value {
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme?.colors?.primaryButtCol || '#9c5a2e'};
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 6px;
  }

  .currency {
    font-size: 13px;
    font-weight: 600;
    opacity: 0.85;
  }
`

export const BillBody = styled.div`
  padding: 4px 16px 0;
`

export const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f3eee9;

  &:last-child {
    border-bottom: none;
  }
`

export const DetailTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #6b5b4b;
  flex-shrink: 0;
`

export const DetailVal = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #404040;
  text-align: end;
  word-break: break-all;
`

export const StatusVal = styled.span`
  font-weight: 600;
  ${({ success }) =>
    success
      ? css`color: #07b558;`
      : css`color: #9e0823;`
  }
`

export const BillFooter = styled.div`
  padding: 12px 16px 16px;
`

export const ErrorCard = styled.div`
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 14px;
  padding: 24px 16px;
  text-align: center;
  color: #9e0823;
  font-weight: 600;
  box-shadow: 0 6px 24px rgba(66, 35, 3, 0.1);
`

export const LoadingCard = styled(ErrorCard)`
  color: #6b5b4b;
`
